<template>
  <v-card
    flat
    class="pa-4 md:pa-6 bg-white"
    rounded="xl"
    style="border: 1px solid #f1f5f9 !important"
  >
    <!-- Cabeçalho Executivo -->
    <!-- <div class="text-center mb-8 px-2">
      <h2
        class="text-h5 md:text-h4 font-weight-black text-slate-900 tracking-tight mb-2"
        style="color: #0f172a"
      >
        Programa Jovem Aprendiz Cooperativo 2026
      </h2>
      <p
        class="body-2 text--darken-1 font-weight-medium mx-auto"
        style="max-width: 600px; color: #64748b"
      >
        Uma oportunidade corporativa estruturada para aprender, desenvolver
        competências e construir uma carreira sólida na Coasul.
      </p>
    </div> -->

    <v-card-text class="pa-0">
      <!-- Grid Principal: Detalhes e Banner Oficial -->
      <v-row align="stretch" class="mb-2">
        <!-- Coluna Esquerda: Requisitos e Linha do Tempo de Etapas -->
        <v-col cols="12" md="6" class="d-flex flex-column justify-between">
          <div class="space-y-4">
            <!-- Card de Requisitos e Áreas -->
          <!-- Card de Requisitos e Áreas Refinado -->
            <div class="pa-4 rounded-xl mb-4" style="background-color: #f8fafc; border: 1px solid #e2e8f0;">
              <div class="mb-4">
                <div class="d-flex align-center mb-2">
                  <div class="d-flex align-center justify-center shrink-0 mr-2" style="width: 24px; height: 24px; border-radius: 50%; background-color: #e2e8f0;">
                    <v-icon x-small color="green darken-3">mdi-shield-check-outline</v-icon>
                  </div>
                  <span class="text-caption font-weight-black text-uppercase" style="color: #334155; letter-spacing: 0.08em;">Requisitos Obrigatórios</span>
                </div>
                <ul class="pl-8 caption font-weight-medium" style="color: #475569; line-height: 1.5;">
                  <li>Faixa etária entre 14 e 17 anos.</li>
                  <li>Estar cursando regularmente ou ter concluído o ensino médio.</li>
                </ul>
              </div>

              <div class="pt-3" style="border-top: 1px solid #e2e8f0;">
                <div class="d-flex align-center mb-2">
                  <div class="d-flex align-center justify-center shrink-0 mr-2" style="width: 24px; height: 24px; border-radius: 50%; background-color: #e2e8f0;">
                    <v-icon x-small color="green darken-3">mdi-domain</v-icon>
                  </div>
                  <span class="text-caption font-weight-black text-uppercase" style="color: #334155; letter-spacing: 0.08em;">Áreas de Atuação</span>
                </div>
                <p class="caption font-weight-bold mb-0 pl-8" style="color: #0f172a;">
                  Administrativas, Almoxarifado, Manutenção e Mercado.
                </p>
              </div>
            </div>

            
            <!-- Timeline Moderna Refinada e Contemporânea -->
            <div
              class="pa-4 rounded-xl"
              style="background-color: #f0fdf4; border: 1px solid #bbf7d0"
            >
              <div class="d-flex align-center mb-4">
                <v-icon small color="green darken-4" class="mr-2"
                  >mdi-timeline-clock-outline</v-icon
                >
                <span
                  class="text-caption font-weight-black text-uppercase"
                  style="color: #166534; letter-spacing: 0.08em"
                  >Cronograma do Processo Seletivo</span
                >
              </div>

              <div class="timeline-wrapper pl-1">
                <!-- Item 1 -->
                <div
                  class="timeline-item pb-4 d-flex"
                  style="position: relative"
                >
                  <!-- Linha conectora vertical -->
                  <div
                    style="
                      position: absolute;
                      left: 15px;
                      top: 28px;
                      bottom: -4px;
                      width: 2px;
                      background-color: #86efac;
                    "
                  ></div>

                  <!-- Ícone / Marcador Moderno -->
                  <div
                    class="d-flex align-center justify-center shrink-0 mr-3"
                    style="
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      background-color: #dcfce7;
                      border: 2px solid #86efac;
                      z-index: 1;
                    "
                  >
                    <v-icon x-small color="green darken-3"
                      >mdi-file-document-edit-outline</v-icon
                    >
                  </div>

                  <!-- Conteúdo -->
                  <div class="pt-1">
                    <div
                      class="caption font-weight-black"
                      style="
                        color: #14532d;
                        font-size: 0.82rem !important;
                        line-height: 1.2;
                      "
                    >
                      Até 28/09
                    </div>
                    <div
                      class="caption font-weight-medium"
                      style="color: #334155"
                    >
                      Cadastramento e envio de currículos
                    </div>
                  </div>
                </div>

                <!-- Item 2 -->
                <div
                  class="timeline-item pb-4 d-flex"
                  style="position: relative"
                >
                  <div
                    style="
                      position: absolute;
                      left: 15px;
                      top: 28px;
                      bottom: -4px;
                      width: 2px;
                      background-color: #86efac;
                    "
                  ></div>

                  <div
                    class="d-flex align-center justify-center shrink-0 mr-3"
                    style="
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      background-color: #dcfce7;
                      border: 2px solid #86efac;
                      z-index: 1;
                    "
                  >
                    <v-icon x-small color="green darken-3"
                      >mdi-account-voice</v-icon
                    >
                  </div>

                  <div class="pt-1">
                    <div
                      class="caption font-weight-black"
                      style="
                        color: #14532d;
                        font-size: 0.82rem !important;
                        line-height: 1.2;
                      "
                    >
                      A partir de 06/10
                    </div>
                    <div
                      class="caption font-weight-medium"
                      style="color: #334155"
                    >
                      Realização das etapas de entrevistas
                    </div>
                  </div>
                </div>

                <!-- Item 3 -->
                <div
                  class="timeline-item pb-4 d-flex"
                  style="position: relative"
                >
                  <div
                    style="
                      position: absolute;
                      left: 15px;
                      top: 28px;
                      bottom: -4px;
                      width: 2px;
                      background-color: #86efac;
                    "
                  ></div>

                  <div
                    class="d-flex align-center justify-center shrink-0 mr-3"
                    style="
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      background-color: #dcfce7;
                      border: 2px solid #86efac;
                      z-index: 1;
                    "
                  >
                    <v-icon x-small color="green darken-3"
                      >mdi-clipboard-check-outline</v-icon
                    >
                  </div>

                  <div class="pt-1">
                    <div
                      class="caption font-weight-black"
                      style="
                        color: #14532d;
                        font-size: 0.82rem !important;
                        line-height: 1.2;
                      "
                    >
                      A partir de 15/10
                    </div>
                    <div
                      class="caption font-weight-medium"
                      style="color: #334155"
                    >
                      Convocação dos selecionados e solicitação de documentos
                    </div>
                  </div>
                </div>

                <!-- Item 4 (Último sem linha passando por baixo) -->
                <div class="timeline-item d-flex" style="position: relative">
                  <div
                    class="d-flex align-center justify-center shrink-0 mr-3"
                    style="
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      background-color: #dcfce7;
                      border: 2px solid #86efac;
                      z-index: 1;
                    "
                  >
                    <v-icon x-small color="green darken-3"
                      >mdi-school-outline</v-icon
                    >
                  </div>

                  <div class="pt-1">
                    <div
                      class="caption font-weight-black"
                      style="
                        color: #14532d;
                        font-size: 0.82rem !important;
                        line-height: 1.2;
                      "
                    >
                      02/11 a 15/11
                    </div>
                    <div
                      class="caption font-weight-medium"
                      style="color: #334155"
                    >
                      Previsão de início oficial das turmas
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>

        <!-- Coluna Direita: Arte de Divulgação Controlada -->
        <v-col
          cols="12"
          md="6"
          class="d-flex flex-column align-center justify-center pt-4 pt-md-0"
        >
          <div
            class="w-full pa-3 rounded-xl d-flex flex-column align-center justify-center h-full"
            style="background-color: #f8fafc; border: 1px solid #e2e8f0"
          >
            <div
              class="image-container rounded-lg overflow-hidden d-flex justify-center align-center w-100"
              style="max-width: 320px"
            >
              <v-img
                :src="arteDivulgacao"
                alt="Divulgação Programa Jovem Aprendiz Coasul"
                contain
                max-height="420"
                class="rounded-lg mx-auto"
              ></v-img>
            </div>
            <span
              class="overline text-slate-400 mt-2 font-weight-bold"
              style="letter-spacing: 0.1em; color: #94a3b8"
              >MATERIAL OFICIAL DE DIVULGAÇÃO</span
            >
          </div>
        </v-col>
      </v-row>

     <!-- Rodapé de Contato Institucional Refinado -->
      <div
        class="mt-6 pt-4 d-flex flex-column flex-sm-row align-center justify-space-between gap-3 px-2"
        style="border-top: 1px solid #f1f5f9;"
      >
        <div class="d-flex align-center">
          <div class="d-flex align-center justify-center shrink-0 mr-2.5" style="width: 28px; height: 28px; border-radius: 50%; background-color: #f0fdf4;">
            <v-icon x-small color="green darken-3">mdi-whatsapp</v-icon>
          </div>
          <span class="caption font-weight-medium" style="color: #64748b;">
            Dúvidas sobre o processo? Nossa equipe está à disposição no canal oficial.
          </span>
        </div>

        <v-btn
          color="emerald darken-1"
          rounded
          dark
          depressed
          small
          class="font-weight-bold px-5 text-none elevation-0"
          style="background-color: #059669 !important; letter-spacing: 0.02em;"
          @click="abrirWhatsapp()"
        >
          <v-icon left size="16">mdi-chat-processing-outline</v-icon>
          (46) 99929-0042
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import arteJovemAprendiz from "../../assets/arte-jovem-aprendiz-2026.png";

export default {
  name: "InformacoesJovemAprendiz2026",
  data: () => ({
    arteDivulgacao: arteJovemAprendiz,
  }),
  methods: {
    ...mapActions(["abrirWhatsapp"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>